// Track navigation history
const HISTORY_KEY = 'navigation_history';
const MAX_HISTORY = 50;

export const navigationHistory = {
  // Initialize or get existing history
  getHistory: () => {
    try {
      const history = sessionStorage.getItem(HISTORY_KEY);
      return history ? JSON.parse(history) : [];
    } catch (e) {
      return [];
    }
  },

  // Add a path to history
  addPath: (path) => {
    const history = navigationHistory.getHistory();
    // Don't add duplicate consecutive entries
    if (history.length > 0 && history[history.length - 1] === path) {
      return;
    }
    history.push(path);
    // Keep only last MAX_HISTORY items
    const trimmedHistory = history.slice(-MAX_HISTORY);
    sessionStorage.setItem(HISTORY_KEY, JSON.stringify(trimmedHistory));
  },

  // Find the most recent occurrence of any of the specified paths
  findMostRecentMatch: (targetPaths) => {
    const history = navigationHistory.getHistory();
    // Search from the end (most recent) backwards
    for (let i = history.length - 1; i >= 0; i--) {
      const path = history[i];
      if (targetPaths.some(targetPath => path.includes(targetPath))) {
        return path;
      }
    }
    return null;
  },

  // Clear history
  clear: () => {
    sessionStorage.removeItem(HISTORY_KEY);
  }
};